import { FC, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import { useGetReportsByCatTypeQuery } from "../../api/network/reportApiServices";
import {
  setReportsByType,
  setReportVisibleColumns,
} from "../../api/store/commonSlice";
import { TReportStatus } from "../../api/types/Report";
import { APP_CONFIG, REPORT_TYPES } from "../../constants/constants";
import { localStorageKeys } from "../../utils/localStorageItems";

const ReportPagesWrapper: FC = () => {
  // const reportsByType: { [key in REPORT_CATEGORIES]: TReport[]; }
  //   = useSelector((state: any) => state.commonReducer.reportsByType);
  const dispatch = useDispatch();

  const reportTypeIndex = useRef<keyof typeof REPORT_TYPES>(
    Object.keys(REPORT_TYPES)[0] as keyof typeof REPORT_TYPES
  );
  const [reportTypeCategoryParams, setReportTypeCategoryParams] = useState({
    type: REPORT_TYPES[reportTypeIndex.current],
    // category: REPORT_CATEGORIES[reportCategoryIndex.current],
    page: 1,
    page_size: APP_CONFIG.LISTINGS.LARGE_PAGE_SIZE,
  });
  const {
    data: dataReportsByCategory,
    isFetching: isFetchingreportsByCategory,
  } = useGetReportsByCatTypeQuery(reportTypeCategoryParams);

  // sequentially call all report types to get all reports
  useEffect(() => {
    if (isFetchingreportsByCategory) {
      dispatch(
        setReportsByType({
          type: reportTypeCategoryParams.type,
          reports: { loading: true } as TReportStatus,
        })
      );
      return;
    }
    if (!!dataReportsByCategory) {
      if (APP_CONFIG.DEBUG.REPORTS)
        console.log(
          "dispatch setReportsByCategory",
          reportTypeCategoryParams.type
        );
      dispatch(
        setReportsByType({
          type: reportTypeCategoryParams.type,
          reports: dataReportsByCategory.results,
        })
      );
    }
    if (APP_CONFIG.DEBUG.REPORTS)
      console.log(
        `${reportTypeCategoryParams.type} - datareportsByCategory`,
        dataReportsByCategory
      );
    const reportTypes = Object.keys(
      REPORT_TYPES
    ) as (keyof typeof REPORT_TYPES)[];
    const nextIndex = reportTypes.indexOf(reportTypeIndex.current) + 1;
    if (nextIndex < reportTypes.length) {
      reportTypeIndex.current = reportTypes[nextIndex];
      setReportTypeCategoryParams({
        type: REPORT_TYPES[reportTypeIndex.current],
        page: 1,
        page_size: APP_CONFIG.LISTINGS.LARGE_PAGE_SIZE,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetchingreportsByCategory]);

  // retrieve all report columns from local storage and save into redux store
  useEffect(() => {
    const lsItems = { ...localStorage };
    Object.keys(lsItems).forEach((lsKey) => {
      if (lsKey.includes(localStorageKeys.columns.ReportsPrefix)) {
        const columns = JSON.parse(lsItems[lsKey]);
        // console.log('lsKey', lsKey, 'columns', columns);
        dispatch(
          setReportVisibleColumns({
            type: lsKey,
            columns,
          })
        );
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Outlet />;
};

export default ReportPagesWrapper;
